import { SITE_ORIGIN } from './seo';

/** Verified against the GST REG-06 certificate (27AATCM9449D1ZU, issued 14/10/2025). */
export const ORGANISATION_LD = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': SITE_ORIGIN + '/#organisation',
  name: 'Mechtron Water Services',
  legalName: 'Mechtron Technical Services Private Limited',
  url: SITE_ORIGIN,
  logo: SITE_ORIGIN + '/assets/images/logo.png',
  image: SITE_ORIGIN + '/assets/images/waste-water-treatment-plant.jpg',
  description:
    'Design, manufacture, supply, installation and commissioning of sewage and effluent ' +
    'treatment plants and equipment, plus instrument calibration services.',
  telephone: '+91-89836-43660',
  email: 'info@mechtronservices.com',
  foundingDate: '2025',
  vatID: '27AATCM9449D1ZU',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Shop No. 20, Ground Floor, Yashwant Deep, Agashi Road, near Central Park, Bolinj',
    addressLocality: 'Vasai Virar',
    addressRegion: 'Maharashtra',
    postalCode: '401303',
    addressCountry: 'IN'
  },
  geo: { '@type': 'GeoCoordinates', latitude: 19.4591, longitude: 72.7604 },
  areaServed: { '@type': 'Country', name: 'India' },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '09:30', closes: '19:00'
  }],
  sameAs: ['https://www.indiamart.com/mechtron-services/']
};

export const WEBSITE_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': SITE_ORIGIN + '/#website',
  url: SITE_ORIGIN,
  name: 'Mechtron Water Services',
  publisher: { '@id': SITE_ORIGIN + '/#organisation' },
  inLanguage: 'en-IN'
};

export function breadcrumbLd(trail: Array<{ name: string; path: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((t, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: t.name,
      item: SITE_ORIGIN + t.path
    }))
  };
}

export function productLd(p: { slug: string; name: string; summary: string; stage: string; image?: string }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: p.name,
    description: p.summary,
    category: p.stage,
    image: SITE_ORIGIN + (p.image || '/assets/images/waste-water-treatment-plant.jpg'),
    brand: { '@type': 'Brand', name: 'Mechtron' },
    manufacturer: { '@id': SITE_ORIGIN + '/#organisation' },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceCurrency: 'INR',
      url: SITE_ORIGIN + '/equipment/' + p.slug,
      seller: { '@id': SITE_ORIGIN + '/#organisation' }
    }
  };
}
